module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__lightswan"
  }, [_c('div', {
    staticClass: "case-study__photo-background-container"
  }, [_c('div', {
    staticClass: "case-study__photo-background"
  }, [_c('img', {
    ref: "paraPhoto",
    staticClass: "case-study__photo",
    attrs: {
      "src": "/assets/imgs/case-study/lightswan/card.png",
      "srcset": "/assets/imgs/case-study/lightswan/card@2x.png 2x",
      "alt": ""
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "case-study__colors case-study__row"
  }, [_c('div', {
    staticClass: "case-study__title"
  }, [_vm._v("Colors")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__color-blocks"
  }, _vm._l((_vm.colors), function(color) {
    return _c('div', {
      staticClass: "case-study__color-block"
    }, [_c('div', {
      staticClass: "case-study__color",
      style: ('background-color: ' + color.hex)
    }), _vm._v(" "), _c('div', {
      staticClass: "case-study__mini-title"
    }, [_vm._v(_vm._s(color.hex))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "case-study__home"
  }, [_c('div', {
    staticClass: "case-study__line case-study__row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__mobile-screen"
  }, [_c('div', {
    staticClass: "case-study__screen-circle"
  }, [_c('img', {
    ref: "iphone1",
    staticClass: "case-study__mobile-screen__img",
    attrs: {
      "src": "/assets/imgs/case-study/lightswan/home-mobile.png",
      "srcset": "/assets/imgs/case-study/lightswan/home-mobile@2x.png 2x",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "case-study__full-screenshot"
  }, [_c('img', {
    ref: "bg1",
    staticClass: "case-study__full-screenshot__bg",
    attrs: {
      "src": "/assets/imgs/case-study/lightswan/screen-bg.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "case-study__full-screenshot__img case-study__row case-study__img ",
    attrs: {
      "src": "/assets/imgs/case-study/lightswan/home-desktop.jpg",
      "srcset": "/assets/imgs/case-study/lightswan/home-desktop@2x.jpg 2x",
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "case-study__line case-study__row case-study__article-mobile"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__mobile-screen"
  }, [_c('div', {
    staticClass: "case-study__screen-circle"
  }, [_c('img', {
    ref: "iphone2",
    attrs: {
      "src": "/assets/imgs/case-study/lightswan/article-mobile.png",
      "srcset": "/assets/imgs/case-study/lightswan/article-mobile@2x.png 2x",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "case-study__full-screenshot"
  }, [_c('img', {
    ref: "bg2",
    staticClass: "case-study__full-screenshot__bg",
    attrs: {
      "src": "/assets/imgs/case-study/lightswan/screen-bg.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "case-study__full-screenshot__img case-study__row case-study__img ",
    attrs: {
      "src": "/assets/imgs/case-study/lightswan/article-desktop.jpg",
      "srcset": "/assets/imgs/case-study/lightswan/article-desktop@2x.jpg 2x",
      "alt": ""
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__typography case-study__row"
  }, [_c('div', {
    staticClass: "case-study__title"
  }, [_vm._v("Typography")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__typography-block"
  }, [_c('div', {
    staticClass: "case-study__mini-title"
  }, [_vm._v("\n\t\t\t\tEuropa - titling\n\t\t\t")]), _vm._v(" "), _c('img', {
    staticClass: "case-study__typo-img",
    attrs: {
      "src": "/assets/imgs/case-study/lightswan/typo1.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "case-study__typography-block"
  }, [_c('div', {
    staticClass: "case-study__mini-title"
  }, [_vm._v("\n\t\t\t\tBaskerville - text\n\t\t\t")]), _vm._v(" "), _c('img', {
    staticClass: "case-study__typo-img",
    attrs: {
      "src": "/assets/imgs/case-study/lightswan/typo2.svg",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__title"
  }, [_vm._v("Home")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_vm._v("\n\t\t\t\t\tWe chose to put Jesse Owens on the homepage of Lightswan. It was an important cultural reference for François Pumir and Florian Pittion-Rossillon. It’s also a strong symbol which corresponds to the image they want to give to their company. Forerunner, powerful and limitless.\n\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__row"
  }, [_c('img', {
    staticClass: "case-study__perspective-mockup",
    attrs: {
      "src": "/assets/imgs/case-study/lightswan/perspective-mockup.png",
      "srcset": "/assets/imgs/case-study/lightswan/perspective-mockup@2x.png 2x",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-study__half-block"
  }, [_c('div', {
    staticClass: "case-study__title"
  }, [_vm._v("Article")]), _vm._v(" "), _c('div', {
    staticClass: "case-study__text-content"
  }, [_vm._v("\n\t\t\t\t\tIt was very important to have a blog on the website to share the vision of the company. It's content is the heart of Lightswan's communication strategy. This is why there are many custom blog functionalities like a custom player, A slideshow, different styling for pictures and custom blocks for quotes.\n\t\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55757bf4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/CaseStudy/Lightswan.vue
// module id = 272
// module chunks = 0